/**
 * @generated SignedSource<<64580044fbfb4c323e1e55e17e860c11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PriceIndicatorQuery$variables = {};
export type PriceIndicatorQuery$data = {
  readonly fiatRatesV2: ReadonlyArray<{
    readonly currency: string;
    readonly priceUsd: number;
    readonly percentChangeLastDay: number | null;
  }>;
};
export type PriceIndicatorQuery = {
  variables: PriceIndicatorQuery$variables;
  response: PriceIndicatorQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FiatRate",
    "kind": "LinkedField",
    "name": "fiatRatesV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceUsd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentChangeLastDay",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PriceIndicatorQuery",
    "selections": (v0/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PriceIndicatorQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "dee26118326b209608568fa704780f45",
    "id": null,
    "metadata": {},
    "name": "PriceIndicatorQuery",
    "operationKind": "query",
    "text": "query PriceIndicatorQuery {\n  fiatRatesV2 {\n    currency\n    priceUsd\n    percentChangeLastDay\n  }\n}\n"
  }
};
})();

(node as any).hash = "113681f5ed1d31d763e99a4fa73542d9";

export default node;
